export default {
    'diagram3a3-5': {
        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
        'diagram-description': {
            '1': 'America is the only high-income country whose 25-34 year olds are no better educated than its 55-64 year ',
            '2': 'Children from poor backgrounds are handicapped in completing college and moving upwards',
            '3': 'The increase in graduation rates for the wealthiest US households was 75% higher than the increase for the poorest',
            '4': 'Yet without a college degree, the chances of upward mobility are now quite limited',
            '5': 'As a result, children of prosperous families are likely to grow well off, and children of poor families likely to remain poor'
        },
        'elements': {
            'one': 'Children from poor backgrounds are handicapped in completing college and moving upward',
            'two': 'The increase in graduation rates for the wealthiest US households was 75% higher than the increase for the poorest',
            'three': 'Yet without a college degree, the chances of upward mobility are now quite limited',
            'four': 'As a result, children of prosperous families are likely to stay well off and children of poor families likely to remain poor',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a3/diagram5/i18n/en.js